import React, { useState, useEffect } from "react";
import { Card, Separator, Spinner } from "@lemonadetraining/web-ui";
import { getProgrammingSubscribers } from "@lemonadetraining/web-shared";
import AthleteAvatar from "../AthleteAvatar";

interface ViewListOfSubscribersProps {
  programmingUID: string;
}

interface Subscriber {
  uid: string;
  name: string;
}

const ViewListOfSubscribers: React.FC<ViewListOfSubscribersProps> = ({ programmingUID }) => {
  const [subscribers, setSubscribers] = useState<Subscriber[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadingSubscribers = async () => {
      try {
        const subscribers = await getProgrammingSubscribers(programmingUID);
        setSubscribers(subscribers.data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    loadingSubscribers();
  }, [programmingUID]);

  return (
    <Card className="border-none shadow-none bg-transparent px-4 py-2">
      <h4 className="text-base font-medium">Subscribers</h4>
      <Separator className="my-1" />
      {loading && <Spinner />}
      {!loading &&
        subscribers.length > 0 &&
        subscribers.map((subscriber) => (
          <div key={subscriber.uid} className="flex flex-col gap-1">
            <AthleteAvatar
              key={subscriber.uid}
              AthleteUID={subscriber.uid}
              Name={subscriber.name}
            />
          </div>
        ))}
      {!loading && subscribers.length === 0 && <p>No subscribers yet!</p>}
    </Card>
  );
};

export default ViewListOfSubscribers;
